import React, { useState, useEffect } from "react";
import { Chart } from "primereact/chart";
import { Dropdown } from "primereact/dropdown";
import { useForm, Controller } from "react-hook-form";
import { perCycleData } from "../../../apis/CycleApi";
import moment from "moment";
import ChartDataLabels from "chartjs-plugin-datalabels";
const DonationsChart = (props) => {
  const [donationAmount, setDonationAmount] = useState();
  const cycleData = props.cycleData || []; // Safeguard if it's not passed


  const perCycleDonations = () => {
    const statuses = {
      UPCOMING: { label: "Upcoming", color: 	"#00D4C6", data: [] },
      ACTIVE: { label: "Active", color: "#0095FF", data: [] },
      COMPLETED: { label: "Completed", color: "#00C483", data: [] },
      
    };
  
    const cycleLabels = [];
  
    const sortedCycles = Object.keys(props.donations)
      .sort((a, b) => new Date(a) - new Date(b))
      .slice(0, 4);
  
    for (let cycleDate of sortedCycles) {
      const matchingCycle = props.cycleData.find((c) =>
        moment(c.startDate).isSame(moment(cycleDate), 'day')
      );
  
      const label = matchingCycle?.cycleName || moment(cycleDate).format("MMMM-YYYY");
      cycleLabels.push(label);
  
      const status = matchingCycle?.status || "DEFAULT";
  
      Object.keys(statuses).forEach((key) => {
        statuses[key].data.push(key === status ? props.donations[cycleDate] : 0);
      });
    }
  
    const datasets = Object.values(statuses).map((s) => ({
      label: s.label,
      backgroundColor: s.color,
      data: s.data
    }));
  
    setDonationAmount({
      labels: cycleLabels,
      datasets: datasets
    });
  };
  

  

  
 

  useEffect(() => {
    if (props.donations && props.cycleData.length > 0) {
      perCycleDonations();
    }
  }, [props.donations, props.cycleData]);
  
  

  const getLightTheme = () => {
    let donationsOptions = {
      maintainAspectRatio: false,
      aspectRatio: 0.7,
      plugins: {
        datalabels: {
          color: '#f3f6f4',
          font: {
            size: "14px",
            weight: "600"
          },
          display: function (context) {
            return context.dataset.data[context.dataIndex] > 0; 
          }
        },
        legend: {
          display: true,
          position: 'top',
          labels: {
            color: "#495057"
          }
        }
      },
      scales: {
        x: {
          stacked: true,
          ticks: { color: "#495057" },
          grid: { color: "#e6e6e6" }
        },
        y: {
          stacked: true,
          ticks: { color: "#495057" },
          grid: { color: "#e6e6e6" }
        }
      }
    };
  
    return {
      donationsOptions,
    };
  };
  
  const { donationsOptions } = getLightTheme();

  return (
    <div className="layout-main-height">
      <div className="datatable-doc-demo">
        <div className="card-1">
          <Chart type="bar" data={donationAmount} options={donationsOptions}  plugins={[ChartDataLabels]} />
        </div>
      </div>
    </div>
  );
};

export default DonationsChart;
